
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tidal-dashboard/profile",
      function () {
        return require("private-next-pages/tidal-dashboard/profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tidal-dashboard/profile"])
      });
    }
  